import { render, staticRenderFns } from "./SecondScreen.vue?vue&type=template&id=56e8ab97&scoped=true&"
import script from "./SecondScreen.vue?vue&type=script&lang=js&"
export * from "./SecondScreen.vue?vue&type=script&lang=js&"
import style0 from "./SecondScreen.vue?vue&type=style&index=0&id=56e8ab97&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e8ab97",
  null
  
)

export default component.exports